module.exports = __webpack_public_path__ + "static/media/bowen-33.e5e86fb6.jpg";